module.exports = __webpack_public_path__ + "static/img/cloud_xpress_connect_img_1_en.251549e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/cloud_xpress_connect_img_1_en.png
// module id = X/Bk
// module chunks = 0